import { injectIntl } from "react-intl";
import React, { useState } from "react";
import { OperationType } from "src/helpers/Enums";
import apiService from "src/services/api.service";

const NewStrategy = (props) => {

    const [strategy, setStrategy] = useState(props.type === OperationType.UPDATE ? props.strategy : {
        name: "",
        top_offer: "",
        new_offer: "",
        old_winner: ""
    })

    const handleName = (param) => {
        setStrategy({...strategy, name: param})
    };

    const handleTopOffers = (param) => {
        setStrategy({...strategy, top_offer: param})
    };

    const handleNewOffers = (param) => {
        setStrategy({...strategy, new_offer: param})
    };

    const handleOldWinners = (param) => {
        setStrategy({...strategy, old_winner: param})
    };

    const createUpdateStrategy = () => {
        switch (props.type) {
            case OperationType.CREATE:
                apiService.createStrategy(strategy).then(() => {
                    props.close()
                })
                break
            case OperationType.UPDATE:
                apiService.updateStrategy(strategy).then(() => {
                    props.close()
                })
                break
        }
    }

    const isEnableButton = () => {
        let isEnable = false
        if (strategy?.name && strategy?.top_offer && strategy?.new_offer && strategy?.old_winner) {
            isEnable = true
        }
        return isEnable
    }

    return (
        <div className="NewStrategyModalOverlay">
            <div className="NewStrategyModal">
                <div className={ "w-full flex justify-between" }>
                    <div className={ props.type === OperationType.CREATE ? "NewStrategy" : "NewCreative" }>
                        <img alt={ "Logo" }
                             src={ props.type === OperationType.CREATE ? "/media/icons/purplePlusIcon.svg" : "/media/icons/editIcon.svg" }
                             className={ "w-[18px] h-[18px]" }/>
                        { props.type === OperationType.CREATE ? "New" : "Edit" } Strategy
                    </div>
                    <button className={ "CloseIconButton" } onClick={ props.close }>
                        <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" } className={ "w-5 h-5" }/>
                    </button>
                </div>

                <div className={ "NewStrategyInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>Strategy Name</div>
                    <input className={ "NewStrategyInput" } type="text" placeholder="Enter"
                           onChange={ (e) => handleName(e.target.value) } value={ strategy?.name }/>
                </div>
                <div className={ "NewStrategyInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>Top Offers (%)</div>
                    <input className={ "NewStrategyInput" } type="text" placeholder="Enter"
                           onChange={ (e) => handleTopOffers(e.target.value) } value={ strategy?.top_offer }/>
                </div>
                <div className={ "NewStrategyInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>New Offer (%)</div>
                    <input className={ "NewStrategyInput" } type="text" placeholder="Enter"
                           onChange={ (e) => handleNewOffers(e.target.value) } value={ strategy?.new_offer }/>
                </div>
                <div className={ "NewStrategyInputSection" }>
                    <div className={ "NewStrategyInputTitle" }>Old Winners (%)</div>
                    <input className={ "NewStrategyInput" } type="text" placeholder="Enter"
                           onChange={ (e) => handleOldWinners(e.target.value) } value={ strategy?.old_winner }/>
                </div>
                <div className="modal-actions">
                    <button type="button" onClick={ props.close } className="CloseButton">
                        Close
                    </button>
                    <button className="CreateButton" disabled={!isEnableButton()} onClick={ createUpdateStrategy }>
                        { props.type === OperationType.CREATE ? "Create" : "Save" }
                    </button>
                </div>
            </div>
        </div>
    );
}

export default injectIntl(NewStrategy);
